import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';

@Component({
  selector: 'app-districtwise-statement',
  templateUrl: './districtwise-statement.component.html',
  styleUrls: ['./districtwise-statement.component.scss'],
})
export class DistrictwiseStatementComponent implements OnInit {
  districtwiseData;
  sundayankDate;
  dispatchankDate;
  total_sub_count = 0;
  totalparcel = 0;
  totalanksankhya = 0;
  filtereddistrictwisesubcout = [];
  disRepData = [];
  type: any;
  state: any
  district: any
  distributionMode: any
  subDistributionMode: any
  country: any
  constructor(
    private dialogref: MatDialogRef<DistrictwiseStatementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) { }
  updateStatus: any = false
  issuedate: any
  ngOnInit(): void {
    this.service
      .getDistributionRepresentativeSBhetHastewise()
      .subscribe((res) => {
        this.disRepData = res;
        console.log(this.disRepData);
      });

    this.districtwiseData = this.data['data'];
    this.sundayankDate = this.data['sundaydate'];
    this.dispatchankDate = this.data['dispatchdate'];
    this.type = this.data['type']
    this.updateStatus = this.data['updateStatus']
    this.issuedate = this.data['issueDate']
    this.state = this.data.state;
    this.district = this.data.district;
    this.country = this.data.country;
    this.distributionMode = this.data.distributionMode;
    this.subDistributionMode = this.data.subDistributionMode
    // console.log(this.districtwiseData);

    //hold on for while
    // let checkData = this.uniqueid(
    //   this.districtwiseData,
    //   (a) => a['distribution_rep']
    // );
    if (this.issuedate == undefined) {
      alert("Please Select Issue Date !!");
    }
    if (this.dispatchankDate == undefined) {
      alert("Please Select Dispatch Date!!");
    }


    if (this.state=="") {
     this.calculation();
      }
    if (this.updateStatus) {
       if (this.state && this.state.length != 0) {
      this.getAllDistributerCopiesListByDistrictwiseStatement();
       }


      // this.filtereddistrictwisesubcout = this.filtereddistrictwisesubcout.filter(e => {
      //   return e.district == this.district;
      // });


    } else {
      this.getDistrictwiseStatementList();
    }







    console.log(this.filtereddistrictwisesubcout, "filter")
  }

  uniqueid(data, key) {
    return [...new Map(data.map((x) => [key(x), x])).values()];
  }
  checkAll = false;
  masterSelected: boolean = false;
  selectedIds: any = ""
  deleteDistrictwiseStatemet: any = true;
  checkUncheckAll() {
    this.selectedIds = ""
    this.checkAll = !this.checkAll;
    this.filtereddistrictwisesubcout.forEach(item => item.selected = this.checkAll);

    this.filtereddistrictwisesubcout.forEach((element: any) => {
      if (element.selected) {
        if (this.selectedIds == "") {
          this.selectedIds = element.id
        } else {
          this.selectedIds = this.selectedIds + "," + element.id
        }
      }

    });
    // alert(this.selectedIds)
    if (this.selectedIds == "") {
      this.deleteDistrictwiseStatemet = true;
    } else {
      this.deleteDistrictwiseStatemet = false;
    }
  }
  isAllSelected() {
    this.selectedIds = ""
    this.masterSelected = this.filtereddistrictwisesubcout.every(item => item.selected);
    this.filtereddistrictwisesubcout.forEach((element: any) => {
      if (element.selected) {
        if (this.selectedIds == "") {
          this.selectedIds = element.id
        } else {
          this.selectedIds = this.selectedIds + "," + element.id
        }
      }

    });
    if (this.selectedIds == "") {
      this.deleteDistrictwiseStatemet = true;
    } else {
      this.deleteDistrictwiseStatemet = false;
    }
    // alert(this.selectedIds)
  }

  saveSubscriptionBarcodesDataEntry() {

    console.log(this.filtereddistrictwisesubcout);
    const filteredData = this.filtereddistrictwisesubcout.map((item) => ({
      issue_date: this.issuedate,
      country: item.country,
      state: item.state,
      number_of_subscribers: item.sub,
      total: this.total_sub_count,
      added_by: 1,
      publish_date: this.convertDateFormat(this.dispatchankDate),
      delivery_mode: item.delivery_mode,
      dispatch_date: this.convertDateFormat(this.dispatchankDate),
      no_of_books_in_bundle: item.parcel.split("=")[1],
      bundle_count: item.parcel.split("=")[0],
      district: item.district,
      allDistributerId:item.id,
    }));
    console.log(filteredData);
    this.service.saveDistrictwiseStatementDataEntry(filteredData).subscribe((data) => {
      alert('Districtwise Statements Save Successfully!');
    });
  }

  convertDateFormat(dateStr: string): string {
    const [day, month, year] = dateStr.split('/');
    return `${year}/${month}/${day}`;
  }
  getDistrictwiseStatementList() {
    this.total_sub_count = 0
    this.totalparcel = 0
    this.totalanksankhya = 0;
    const request = {
      issue_date: this.issuedate,
      country: "भारत",
      districts: this.district,
      state: this.state
    }
    this.service.getDistrictwiseStatementList(request).subscribe((data: any) => {
      this.filtereddistrictwisesubcout = data.data;
      this.filtereddistrictwisesubcout.forEach(element => {
        this.total_sub_count = Number(this.total_sub_count) + Number(element.sub);
        let splitArr = element.parcel.split("=")
        this.totalparcel = Number(this.totalparcel) + Number(splitArr[0]);
        this.totalanksankhya = Number(this.totalanksankhya) + Number(splitArr[1]);
      });



    });
  }

  deleteDistrictwiseStatementList() {
    const request = {
      ids: this.selectedIds
    }
    this.service.deleteDistrictwiseStatement(request).subscribe((data: any) => {
      this.getDistrictwiseStatementList();
      console.log("Deleted Successfully !!")
    });
  }


  filtereddistrictwisesubcout1: any
  getAllDistributerCopiesListByDistrictwiseStatement() {
    // this.filtereddistrictwisesubcout = []
    const request = {
      "issue_date": this.issuedate,
      "countryName": this.country[0],
      "stateName": this.state[0],
      "distributionMode": this.distributionMode || this.type,
      "subDistributionMode": this.subDistributionMode || "जी.पी.ओ",
      "districtName": this.district,
      "talukaName": "",
      "pincode": ""
    }
    this.service.getAllDistributerCopiesListByDistrictwiseStatement(request).subscribe((data: any) => {
      let dataList = data.data;
      this.calculation()
      const districtSummary: any = {};

      dataList.forEach(item => {
        const { district, taluka, prati,id } = item;

        if (!districtSummary[district]) {
          districtSummary[district] = {
            district: district,
            talukaCount: 0,
            pratiSum: 0,
            id:id
          };
        }

        districtSummary[district].talukaCount += 1; // Count every record (even if taluka name is same)
        districtSummary[district].pratiSum += Number(prati);
      });

      // Convert to list
      const districtWiseList = Object.values(districtSummary).map((entry: any) => ({
        district: entry.district,
        talukaCount: entry.talukaCount,
        pratiSum: entry.pratiSum,
        parcel: `${entry.talukaCount}=${entry.pratiSum}`,
        id:entry.id,
      }));


      // Step 1: Create a map from districtWiseList
      const districtMap = new Map<string, any>();

      districtWiseList.forEach(entry => {
        districtMap.set(entry.district, {
          talukaCount: entry.talukaCount,
          pratiSum: entry.pratiSum,
          parcel: entry.parcel,
          id:entry.id
        });
      });

      // Step 2: Merge into filtereddistrictwisesubcout
      let filtereddistrictwisesubcout1 = this.filtereddistrictwisesubcout.map(item => {
        const match = districtMap.get(item.district);

        return {
          ...item,
          talukaCount: match?.talukaCount || 0,
          pratiSum: match?.pratiSum || 0,
          parcel: match?.parcel || "0=0",
          id:match?.id
         };
      });


        this.total_sub_count = filtereddistrictwisesubcout1.reduce((sum, item) => {
          return sum + Number(item.sub);
        }, 0);
        this.totalparcel = filtereddistrictwisesubcout1.reduce((sum, item) => {
          return sum + Number(item.talukaCount);
        }, 0);
        this.totalanksankhya = filtereddistrictwisesubcout1.reduce((sum, item) => {
          return sum + Number(item.pratiSum);
        }, 0);
      

      this.filtereddistrictwisesubcout = filtereddistrictwisesubcout1;
      console.log(this.filtereddistrictwisesubcout);

    });


  }

  calculation() {
    debugger
    this.total_sub_count = 0;
    this.totalparcel = 0;
    this.totalanksankhya = 0;
    let tempdata = this.uniqueid(this.districtwiseData, (a) => a['district']);

    this.filtereddistrictwisesubcout = [];
    for (let index = 0; index < Object.keys(tempdata).length; index++) {
      let arr = this.districtwiseData.filter(
        (a) => a['district'] == tempdata[index]['district']
      );

      let delivery_mode_unique = this.uniqueid(arr, (a) => a['delivery_mode']);
      // console.log({ delivery_mode_unique });

      let totalTapalCount = 0;
      let parcelval = 0;
      let anksankhya = 0;
      for (let j = 0; j < Object.keys(delivery_mode_unique).length; j++) {
        let arr1 = arr.filter(
          (a) => a['delivery_mode'] == delivery_mode_unique[j]['delivery_mode']
        );

        let hasteTapalJPO = [];
        if (arr1[0]['delivery_mode'] === this.type[0]) {
          totalTapalCount = Object.keys(arr1).length;
          // console.log({ totalTapalCount });
        } else if (arr1[0]['delivery_mode'] === 'हस्ते') {
          hasteTapalJPO = arr1.filter(
            (a) => a['dis_mode'] == 'टपाल' && a['dis_sub_mode'] == 'जी.पी.ओ'
          );

          if (hasteTapalJPO.length > 0) {
            let hasteTapalJPOUnique = this.uniqueid(
              hasteTapalJPO,
              (a) => a['distribution_rep']
            );
            // console.log({ hasteTapalJPOUnique });
            parcelval = hasteTapalJPOUnique.length;
            hasteTapalJPOUnique.map((tapal) => {
              let ank = hasteTapalJPO.filter(
                (a) => a['distribution_rep'] === tapal['distribution_rep']
              );
              // console.log({ ank });
              anksankhya += ank.length;
            });
          }
        }
      }

      this.filtereddistrictwisesubcout.push({
        name: tempdata[index]['name'],
        Subscription_Type: tempdata[index]['Subscription_Type'],
        address: tempdata[index]['address'],
        country: tempdata[index]['country'],
        delivery_mode: tempdata[index]['delivery_mode'],
        district: tempdata[index]['district'],
        pincode: tempdata[index]['pincode'],
        state: tempdata[index]['state'],
        sub_perid_to_date: tempdata[index]['sub_perid_to_date'],
        taluka: tempdata[index]['taluka'],
        sub: totalTapalCount,
        parcel: `${parcelval}=${anksankhya}`,
        isSelected: false
      });

      this.total_sub_count += totalTapalCount;
      this.totalparcel += parcelval;
      this.totalanksankhya += anksankhya;
    }

    console.log(this.filtereddistrictwisesubcout, "withoutfilter")

    this.filtereddistrictwisesubcout = this.filtereddistrictwisesubcout.filter(e => {
      return e.state == this.state;
    });
  }
}
